const merge = require('lodash.merge');

const {get, post, patch, del} = require('./agent');

module.exports = (global_options) => {
  return {
    create: (data, local_options) => {

      const options = merge({}, global_options, local_options);
      return post('/invites', data, options);

    },
    get: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/invites/${id}`, options);
    },
    accept: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      const data = {
        used: true,
      };
      return post(`/invites/${id}`, data, options);
    }
  }
}



// WEBPACK FOOTER //
// ../covert/invites.js